module.exports = __webpack_public_path__ + "img/Boy_030035.555219f1.png";